import useLoader from "../../hooks/useLoader";
import {Button, Grid} from "@mui/material";
import Box from "@mui/material/Box";
import TablePagination from "@mui/material/TablePagination";
import TextField from "@mui/material/TextField";
import {makeStyles} from "@mui/styles";
import {Table} from "antd";
import React, {useCallback, useEffect, useMemo, useState} from "react";
import {useTranslation} from "react-i18next";
import DomainSelect from "../Select/DomainSelect";
import FilterDatePicker from "../DatePicker/FilterDatePiecker";
import FilterDatePicker2 from "../DatePicker/FilterDatePicker2";
import {cleanObject} from "../../functions/viewDataMap";
import CRUDFilter from "./CRUDFilter";
import CollapsibleCRUDTable from "./CollapsibleCRUDTable";
import CRUDTableContext from "./CRUDTableContext";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";

const useStyles = makeStyles({
    trClickable: {
        cursor: "pointer",
    },
});


const Filter2 = ({
                       extraFilter,
                       filter,
                       setFilter,
                       defaultFilter,
                       searchPlaceholder,
                       search,
                       searchByIdHide,                      
                       rowClassNameHandler,                                              
                       reloadValue,                       
                       searchByOperator,
                       extraHeader,
                       filterFields,                       
                       searchFields,
                       sendFilterValues,
                       searchBy,                       
                       reducerFilterKey,
                       reducerParentKey,                       
                       onDidRemoveFilter,
                       wait,
                       filterId,
                       ...props
                   }) => {
    const {t} = useTranslation();

    const classes = useStyles();

    const [searchValue, setSearchValue] = useState(defaultFilter || {});
    const [advancedSearchValue, setAdvancedSearchValue] = useState({});

    useEffect(() => {
        if (!filterId) {
            return;
        }

        const oldFilterString = localStorage.getItem(filterId);
        const oldFilter = oldFilterString ? JSON.parse(oldFilterString) : null;

        if (!oldFilter) {
            return;
        }

        setFilter(oldFilter.filter);
        setSearchValue(oldFilter.searchValue);
        setAdvancedSearchValue(oldFilter.advancedSearchValue);
    }, [filterId]);

    const handleSearchPanelChange = (val, key, compareType, operandPosition, filterType, key1, key2) => {
        switch (filterType) {
            case "normal":
            case "text":
                setSearchValue(state => {
                    let filter = state[key1 || key];

                    const stateObject = {
                        ...state
                    };

                    if (key2) {
                        if (!filter) {
                            filter = {};
                        }
                        filter[key2] = {
                            ...filter[key2],
                            operator: compareType,
                            [`operand${operandPosition}`]: val,
                        }
                        stateObject[key1 || key] = filter;
                    } else {
                        stateObject[key1 || key] = {
                            ...state[key1 || key],
                            operator: compareType,
                            [`operand${operandPosition}`]: val,
                        };
                    }
                    if (!val) {
                        delete stateObject[key1 || key][`operand${operandPosition}`];
                        if (!stateObject[key1 || key].operand1 && !stateObject[key1 || key].operand2) {
                            stateObject[key1 || key] = null;
                        }
                    }
                    return stateObject;
                });
                break
            case "advanced":
                setAdvancedSearchValue(state => {
                    const stateObject = {
                        ...state,
                        [key]: val
                    }
                    if (!val) {
                        stateObject[key] = null
                    }
                    return stateObject
                })
                break

        }


    };
    const applyFilter = () => {
        cleanObject(searchValue);

        setFilter({
            //...state,
            ...searchValue,
            // advancedFilter: {
            //     ...advancedSearchValue
            // }
        });

        if (!filterId) {
            return;
        }

        const currentFilter = {
            filter: filter,
            searchValue: searchValue,
            advancedSearchValue: advancedSearchValue
        }
        localStorage.setItem(filterId, JSON.stringify(currentFilter));
    }
    const removeFilter = () => {
        setSearchValue({})
        setAdvancedSearchValue({})
        setFilter({});

        onDidRemoveFilter && onDidRemoveFilter();

        if (!filterId) {
            return;
        }

        const currentFilter = {
            filter: {},
            searchValue: {},
            advancedSearchValue: {}
        }
        localStorage.setItem(filterId, JSON.stringify(currentFilter));
    }
    return (
        <>{
            (searchFields || filterFields) && <CRUDFilter filter={filter}>
                {searchFields && searchFields.map((field, idx) => {
                    return (
                        <Box
                            key={idx}
                            sx={{
                                margin: "0 0 0 0",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                            }}
                        >
                            <TextField
                                type="text"
                                label={field.title}
                                value={(() => {
                                    switch (field.filterType) {
                                        case "normal":
                                            let value = searchValue[field.key1 || field.key];
                                            if (field.key2 && value) {
                                                value = value[field.key2];
                                            }
                                            return value?.[`operand${field.operandPosition}`] || ""
                                        case "advanced":
                                            return advancedSearchValue?.[field.key] || ""
                                    }
                                })()}
                                style={{
                                    margin: "8px 0"
                                }}
                                onChange={(ev) => handleSearchPanelChange(ev.target.value, field.key, field.compareType, field.operandPosition, field.filterType,
                                    field.key1, field.key2)}

                            />
                        </Box>
                    )
                })}

                <Grid container style={{
                    margin: "8px 0 8px -10px"
                }} xs={12}>
                    {filterFields && filterFields.map((field, idx) => {
                        switch (field.type) {
                            case "normal":
                                return <Grid key={idx} style={{
                                    marginLeft: "10px"
                                }} item xs={2}>
                                    <DomainSelect
                                        label={field.title}
                                        fullWidth
                                        margin={"none"}
                                        filterQuery={field.filterQuery}
                                        reducerKey={field.reducerKey}
                                        reducerArrayKey={field.reducerArrayKey}
                                        reducerAction={field.reducerAction}
                                        reducerCountKey={field.reducerCountKey}
                                        parentKey={field.parentKey}
                                        parentKey2={field?.parentKey2}
                                        parentKey3={field?.parentKey3}
                                        parentId={field.parentKey && searchValue[field.parentKey]}
                                        parentId2={field?.parentKey2 && searchValue[field?.parentKey2]}
                                        parentId3={field?.parentKey3 && searchValue[field?.parentKey3]}
                                        optionLabelKey={field.optionLabelKey}
                                        initialOptions={field.options}
                                        filter={field.filter}
                                        value={(() => {
                                            switch (field.filterType) {
                                                case "normal":
                                                    let value = searchValue[field.key1 || field.key];
                                                    if (field.key2 && value) {
                                                        value = value[field.key2];
                                                    }
                                                    return value?.[`operand${field.operandPosition}`] || null
                                                case "advanced":
                                                    return advancedSearchValue?.[field.key] || ""
                                            }
                                        })()}
                                        filterOptions = {field.key === "divisionId" ? (opt) => !searchValue["departmentId"]?.[`operand1`] || (opt.departmentId === searchValue["departmentId"]?.[`operand1`]) : null}
                                        key={field.key}
                                        onChange={(val) => {
                                            if (sendFilterValues && (field.reducerKey && val)) {
                                                sendFilterValues(field.reducerKey, val)
                                            }
                                            handleSearchPanelChange(val, field.key, field.compareType, field.operandPosition, field.filterType, field.key1, field.key2)
                                            field.onChange && field.onChange(val);
                                        }}
                                    />
                                </Grid>
                            case "date":
                                return <Grid key={idx} style={{
                                    marginLeft: "10px"
                                }} item xs={2}>
                                    <FilterDatePicker key={field.key} label={field.title} value={(() => {
                                        switch (field.filterType) {
                                            case "normal":
                                                return searchValue[field.key] ? searchValue[field.key][`operand${field.operandPosition}`] ? searchValue[field.key][`operand${field.operandPosition}`] : null : null
                                        }
                                    })()}
                                                      handleFunction={(val) => {
                                                          if (sendFilterValues && (field.key && val)) {
                                                              sendFilterValues(field.key + field.operandPosition, val)
                                                          }
                                                          handleSearchPanelChange(val ? new Date(val) : null, field.key, field.compareType, field.operandPosition, field.filterType)
                                                      }}/>
                                </Grid>
                            case "date2":
                                return <Grid key={idx} style={{
                                    marginLeft: "10px"
                                }} item xs={2}>
                                    <FilterDatePicker2 key={field.key} label={field.title} value={(() => {
                                        switch (field.filterType) {
                                            case "normal":
                                                return searchValue[field.key] ? searchValue[field.key][`operand${field.operandPosition}`] ? searchValue[field.key][`operand${field.operandPosition}`] : null : null
                                        }
                                    })()}
                                                      handleFunction={(e) => {
                                                          const val = e.target.value;
                                                          if (sendFilterValues && (field.key && val)) {
                                                              sendFilterValues(field.key + field.operandPosition, val)
                                                          }
                                                          handleSearchPanelChange(val ? new Date(val) : null, field.key, field.compareType, field.operandPosition, field.filterType)
                                                      }}/>
                                </Grid>
                            case "text":
                                return <Grid key={idx} style={{
                                    marginLeft: "10px"
                                }} item xs={2}>
                                    <TextField key={field.key}
                                        label={field.title}
                                        InputLabelProps={{ shrink: true }}
                                        margin="normal"
                                        style={{marginTop: "0px"}}
                                        value={(() => {
                                            let value = searchValue[field.key1 || field.key];
                                            if (field.key2 && value) {
                                                value = value[field.key2];
                                            }
                                            return value?.[`operand${field.operandPosition}`] || null
                                        })()}
                                        onChange={(e) => {
                                            const val = e.target.value;
                                            if (sendFilterValues && (field.key)) {
                                                sendFilterValues(field.key + field.operandPosition, val)
                                            }
                                            handleSearchPanelChange(val, field.key, field.compareType, field.operandPosition, field.filterType, field.key1, field.key2)
                                        }}/>
                                </Grid>
                            default:
                                <></>
                        }

                    })}


                </Grid>
                <Grid container xs={12} marginBottom={2} justifyContent={"space-between"}>
                    <Grid container xs={10}>
                        <Button onClick={() => applyFilter()}>
                            Найти
                        </Button>
                        <Button style={{marginLeft: "10px"}} onClick={() => removeFilter()}>
                            Сбросить фильтры
                        </Button>
                    </Grid>
                </Grid>
            </CRUDFilter>
        }
        </>
    );
};

export default Filter2;
